// Copyright (c) 2016 Deere & Company

import AttachmentClaimContainer from '../../claim/attachment/state-connector';

export default {
    component: AttachmentClaimContainer,
    name: 'ATTACHMENTS',
    path: 'attachment/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/attachment-claim-route.js